import { Component, OnInit } from '@angular/core';
import { GlobalVariable } from 'src/app/Variable/global-variable';
import {CommonService } from 'src/app/Global-Services/common.service';
import { WindowRefService } from 'src/app/Global-Services/window-ref.service';
import { AppTokenHandler, HTTPStatus } from 'src/app/Global-Services/app-token-handler';
import { Event, Router, ActivatedRoute, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, BehaviorSubject, from } from 'rxjs';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
  standalone: false,
})
export class LayoutComponent implements OnInit {
  LoaderStatus: boolean;
  _win: any;
  constructor(public globalvariable: GlobalVariable, private gservice: CommonService, private _window : WindowRefService,
    private httpStatus: HTTPStatus, private _navigateRoute: Router) {
    this._win = _window.nativeWindow;
    this.httpStatus.getHttpStatus().subscribe((status: boolean) => {
    this.LoaderStatus = status;
  });
  _navigateRoute.events.subscribe((RouterEvent: Event) => {
    if (RouterEvent instanceof NavigationStart) {
        this.LoaderStatus = true;
    }
    if (RouterEvent instanceof NavigationEnd || RouterEvent instanceof NavigationCancel || RouterEvent instanceof NavigationError) {
        this.LoaderStatus = false;
    }
  });

}

  ngOnInit() {
    // // this.GetUserDetails('home');
    // this.globalvariable.User = this.gservice.getUserDetails();
    // if(this.globalvariable.User==null)
    // {
    //  this.gservice.userAuthentication('home');
    // }
  }

//   GetUserDetails(href: string) {
//     this.LoaderStatus = true;
//      this.gservice.userAuthentication(href).subscribe((data: any) => {
//           if (data != null) {
//            sessionStorage.setItem('userToken', data.SecurityToken);
//            sessionStorage.setItem('userDetails', JSON.stringify(data));
//           this.setGlobalVariableValue(data);
//           if (href === null || href === undefined || href === '') {
//            this._navigateRoute.navigate(['home']);
//           } else {
//            this._navigateRoute.navigate([href]);
//           }
//           } else {
//           this.gservice.RedirectToErrorPage('1');
//           }
//      },
//          (err: HttpErrorResponse) => {
//              this.LoaderStatus = false;
//              this._navigateRoute.navigate(['/unAuthorize']);
//          });
//    //this.gservice.userAuthentication(href);
//  }
 setGlobalVariableValue(serverData: any) {
     this.globalvariable.userToken = serverData.SecurityToken;
     this.globalvariable.User = this.gservice.getUserDetails('zero');
 }

}
